export const SPECIAL_BUNDLE_NAME = 'Sendoso.com';
export const IS_TENANT_INVENTORY_ENABLED = false;